
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 48 30"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"48","height":"30","fill":"#D0DBDB","rx":"2"}}),_c('path',{attrs:{"stroke":"#234652","stroke-linecap":"round","stroke-linejoin":"round","d":"M16.794 18.294h4.324m-7.824-6.588h21.412m-20.14-4.941h18.867c1.158 0 2.096.921 2.096 2.059v12.353c0 1.137-.938 2.058-2.096 2.058H14.567c-1.158 0-2.096-.921-2.096-2.058V8.824c0-1.138.938-2.06 2.096-2.06Z"}})])
          )
        }
      }
    